import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from "@/i18n";
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import {BootstrapVue3} from "bootstrap-vue-3";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';

createApp(App)
    .use(router)
    .use(i18n)
    .use(BootstrapVue3)
    .mount('#app')
